import React from 'react';

function ConfirmDialog({ title, message, confirmText = 'Подтвердить', cancelText = 'Отмена', onConfirm, onCancel, variant = 'primary' }) {
  // Порядок как во всех окнах: [Отмена] [Подтвердить] — главная справа (UX-аудит 25.10);
  // необратимое (variant="danger": удалить, в архив) — красная
  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal modal-confirm" style={{ maxWidth: 420 }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">{title}</h2>
          <button className="modal-close" onClick={onCancel}>&times;</button>
        </div>
        <div className="modal-body">
          <div style={{ margin: 0, fontSize: 14, color: '#5E6561', lineHeight: 1.5 }}>{message}</div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onCancel}>{cancelText}</button>
          <button className={variant === 'danger' ? 'btn btn-danger' : 'btn btn-primary'} onClick={onConfirm}>{confirmText}</button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDialog;
